import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from '../BuiltinInstanceMemberCall';
export class MapForEach extends BuiltinInstanceMemberCall {
    canCall(_sb, _func, node) {
        return tsUtils.argumented.getArguments(node).length === 1;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        if (tsUtils.argumented.getArguments(node).length < 1) {
            return;
        }
        sb.emitHelper(node, options, sb.helpers.unwrapMap);
        sb.emitSysCall(node, 'Neo.Iterator.Create');
        sb.visit(tsUtils.argumented.getArguments(node)[0], options);
        sb.emitHelper(node, options, sb.helpers.rawIteratorForEachFunc);
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapUndefined);
        }
    }
}

//# sourceMappingURL=forEach.js.map
